// theme.ts
const colors = {

  // colores primarios

  // rojo
  primary: "#E90C11",
  // rojo suave
  secondary: "#C83440",
  // secondary: "red",

  // azul oscuro
  third: "#013A57",

  // azul: '#0181AE',
  azul: '#013A57',



  // gris
  fifth: "#707070",
  // azul raro
  sixth: "#ffc107",
  // otro tipo de rojo
  seventh: "#17a2b8",


  // colores segundarios, claros

  blanco: "#FFFFFF",
  gris: "#EAEAEA",
  gris2: "#00000029",

  gris3: "#F2F2F2",
  blanco2: "#FBFBFB",

};

// const breakpoints = {
//   small: "576px",
//   medium: "768px",
//   large: "992px",
//   xlarge: "1200px",   
// };


export { colors };
